import { fetchIssueViewRemoteData } from './index.tsx';
import type { RemoteDataGraphQlResponse } from './types.tsx';

export class PrefetchedIssueViewRemoteDataManager {
	private cache = new Map<string, Promise<RemoteDataGraphQlResponse>>();

	prefetch(issueKey: string): void {
		const promise = fetchIssueViewRemoteData(issueKey);
		this.cache.set(issueKey, promise);
	}

	getOrFetch(issueKey: string): Promise<RemoteDataGraphQlResponse> | undefined {
		if (this.cache.has(issueKey)) {
			return this.cache.get(issueKey);
		}

		const promise = fetchIssueViewRemoteData(issueKey);
		this.cache.set(issueKey, promise);
		return promise;
	}

	consume(issueKey: string): Promise<RemoteDataGraphQlResponse> | undefined {
		const promise = this.getOrFetch(issueKey);
		this.cache.delete(issueKey);
		return promise;
	}
}

/**
 * Singleton instance to manage prefetched remote data for issue view.
 */
export const prefetchedRemoteDataManager: PrefetchedIssueViewRemoteDataManager =
	new PrefetchedIssueViewRemoteDataManager();
